<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Extrato Bancário</h3> 
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar Filtro"
              @click="ResetListBank()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">
                  Exibindo Registros de
                  {{ DateTableInitial | date("DD/MM/YYYY") }} até
                  {{ DateTableEnd | date("DD/MM/YYYY") }}.
                </h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-0">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div
                    class="dropdown m-0"
                    :class="window.width < 1880 ? 'dropleft' : ''"
                  >
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis col-lg-12"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar Relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0" style="vertical-align: -webkit-baseline-middle;">Data</th>
                    <th scope="col" class="border-0" style="vertical-align: -webkit-baseline-middle;">
                      Categoria
                    </th>
                    <th scope="col" class="border-0" style="vertical-align: -webkit-baseline-middle;">
                      Descrição
                    </th>
                    <!-- <th scope="col" class="border-0"></th> -->
                    <th scope="col" class="border-0" style="vertical-align: -webkit-baseline-middle;">Valor</th>
                    <!-- <th scope="col" class="border-0"></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(field, index) in BankStatements" :key="index">
                    <td>
                      <img v-if="field.BankAccounts.Bank.Code == '001'" src="@/assets/images/bank_0001.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '033'" src="@/assets/images/bank_0033.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '041'" src="@/assets/images/bank_0041.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '104'" src="@/assets/images/bank_0104.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '237'" src="@/assets/images/bank_0237.jpg" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '341'" src="@/assets/images/bank_0341.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '422'" src="@/assets/images/bank_0422.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '745'" src="@/assets/images/bank_0745.png" height="32px" width="32px" class="logo" />
                      <img v-if="field.BankAccounts.Bank.Code == '748'" src="@/assets/images/bank_0748.png" height="32px" width="32px" class="logo" />


                    </td>
                    
                    <td>
                      <span style="vertical-align: middle;">{{ field.Details[0].EntryDate | date("DD/MM/YYYY") }}</span>
                    </td>
                    <td class="td-with-subs">
                      <div><span style="vertical-align: middle;">{{ field.Details[0].EntryCategory.Name }}</span></div>
                    </td>
                    <td><span style="vertical-align: middle;">{{ field.Details[0].Description }}</span></td>


                    <td>

                      <span v-if="field.Details[0].EntryType.Code == 'D'" style="color: red; vertical-align: middle;">{{ field.Details[0].Amount | currency }} {{ field.Details[0].EntryType.Code }}</span>
                      <span v-if="field.Details[0].EntryType.Code == 'C'" style="color: green; vertical-align: middle;">{{ field.Details[0].Amount | currency }} {{ field.Details[0].EntryType.Code }}</span>

                      

                      

                    </td>
                    


                  </tr>
                  <tr
                    v-if="
                      BankStatements == undefined ||
                        BankStatements == null ||
                        BankStatements.length == 0
                    "
                  >
                    <td colspan="6">Sem Registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      id="mFormBankStatement"
      size="md"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <!-- FILTROSSS -->
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Data Inicial</label>

          <date-field
            v-model="filter.DateInitial"
            format="dd/MM/yyyy"
          ></date-field>
        </d-col>
        <tr></tr>

        <d-col md="6" class="form-group">
          <label>Data Final</label>
          <ValidationProvider :rules="`required`" v-slot="{ invalid }">
            <date-field
              v-model="filter.DateEnd"
              @change="verifyDate()"
            ></date-field>
            <div
              :class="validatedBankStatementForm | showValidateError(invalid)"
              v-if="validatedBankStatementForm"
            ></div>
          </ValidationProvider>
        </d-col>

        <d-col md="12" class="form-group">
          <label>Tipo de Lançamento</label>
          <d-select
            v-model="filter.EntryType.Code"
            :value="0"
            :disabled="pOpened != null"
          >
            <option :value="null" selected>Selecione</option>
            <option
              v-for="(Type, index) in EntryTypes"
              v-bind:value="Type.Code"
              v-bind:key="index"
            >
              {{ Type.Name }}
            </option></d-select
          >
        </d-col>
        <!-- <d-col md="6" class="form-group">
          <ValidationProvider :rules="`required`" v-slot="{ invalid }">
            <label>Código do Histórico</label>
            <input
              placeholder="Insira Codígo"
              type="text"
              class="form-control"
              v-model="filter.CodeHistory"
              v-on:keyup.enter="Filter()"
            />
            <div
              :class="validatedBankStatementForm | showValidateError(invalid)"
              v-if="validatedBankStatementForm"
            ></div>
          </ValidationProvider>
        </d-col> -->

        <!-- <d-col md="12" class="form-group">
          <label>Conta Bancária</label>
          <d-select
            v-model="filter.BankAccounts.Code"
            :disabled="pOpened != null"
            @change="verifyBank()"
          >
            <option :value="null" selected>Selecione</option>

            <option
              v-for="(bankAccount, index) in BankAccounts"
              v-bind:value="bankAccount.Code"
              v-bind:key="index"
            >
              {{ bankAccount.Bank.Code }} -{{ bankAccount.Bank.Name }}
            </option></d-select
          >
        </d-col> -->
        <d-col md="12" class="form-group">
          <label>Descrição</label>
          <d-input
            md="6"
            class="form-group"
            v-model="filter.Description"
            
            :rows="3"
            :max-rows="6"
          >
          </d-input>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          :disabled="
            filter.DateEnd < filter.DateInitial ||
              (filter.BankAccounts.Code != null &&
                filter.Bank.Code != null &&
                SelectedBankAccount.Bank.Code != filter.Bank.Code)
          "
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";

export default {
  name: "BankStatement",
  components: {
    dateField
  },
  data: function() {
    return {
      disabled: 0,
      countFilter: 0,
      BankStatements: [],
      BankAccounts: [],
      Banks: [],
      EntryTypes: [],
      DateNow: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      DateTableEnd: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      DateTableInitial: this.$options.filters.addDay(new Date(), -1),
      ResetFront: {
        EntryDate: null,
        EntryType: null,
        EntryCategory: null,
        Description: null,
        Amount: null,
        bank: null
      },
      filter: {
        DateInitial: this.$options.filters.addDay(new Date(), -7),
        DateEnd: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        Bank: { Code: null },
        EntryType: { Code: null },
        CodeHistory: null,
        BankAccounts: { Code: this.$route.params.idAccount  },
        Description: null
      },
      loadingList: false,
      loadingModal: false,

      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10
      },
      validatedBankStatementForm: false,
      SelectedBankAccount: {
        Bank: { Code: null },
        Code: null
      },
      window: {
        width: 0,
        height: 0
      },
      loadingReport: false
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListBankStatement();
    },
    "pagination.RowsPerPage": function() {
      this.ListBankStatement();
    }
  },
  mounted() {
    this.ListBankStatement();
    this.GetBanks();
    this.GetEntryTypes();
    this.GetBankAccounts();
  },
  methods: {
    verifyDate: function() {
      setTimeout(() => {
        if (this.filter.DateEnd < this.filter.DateInitial) {
          this.validatedBankStatementForm = true;
          this.$makeToast(
            "Data final não pode ser superior ao último dia do mês da Data inicial",
            "danger",
            "Extrato Bancário"
          );
          return;
        } else {
          this.validatedBankStatementForm = false;
        }
      }, 30);
    },
    verifyBank: function() {
      setTimeout(() => {
        const defaultSelectedBankAccount = {
          Bank: { Code: null },
          Code: null
        };
        const found = this.BankAccounts.find(
          bankAccount => bankAccount.Code == this.filter.BankAccounts.Code
        );
        this.SelectedBankAccount =
          found != undefined ? found : defaultSelectedBankAccount;
      }, 40);
    },

    GetBanks: function() {
      this.$store
        .dispatch("GetBanks", {})
        .then(response => {
          this.Banks = response.slice().sort(function(a, b) {
            return a.Name.localeCompare(b.Name);
          });
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao carregar o Banco");
        });
    },
    GetBankAccounts: function() {
      this.$store
        .dispatch("GetBankAccounts", {})
        .then(response => {
          this.BankAccounts = response;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o Banco",
            error
          );
        });
    },
    GetEntryTypes: function() {
      this.$store
        .dispatch("GetEntryTypes", {})
        .then(response => {
          this.EntryTypes = response;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o Banco",
            error
          );
        });
    },
    GetParamsData: function(deletePagination = false) {
      let data = {
        ...this.pagination,
        DateInitial: this.$options.filters.date(
          this.filter.DateInitial,
          "YYYY-MM-DD"
        ),
        DateEnd: this.$options.filters.date(this.filter.DateEnd, "YYYY-MM-DD"),

        CodeHistory: this.filter.CodeHistory,
        Description: this.filter.Description,

        "Object.BankAccounts.Code": this.filter.BankAccounts.Code,
        "Object.BankAccounts.Bank.Code": this.filter.Bank.Code,
        "EntryType.Code": this.filter.EntryType.Code,
        "Object.EntryDate": this.$options.filters.date(
          this.filter.EntryDate,
          "YYYY-MM-DD"
        )
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = this.GetParamsData(true);
      this.$store
        .dispatch("ReportBankStatement", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.DateTableInitial = this.filter.DateInitial;
      this.DateTableEnd = this.filter.DateEnd;
      this.$bvModal.hide("mFilter");
      this.ListBankStatement();
    },
    ResetFilter: function() {
      this.filter = {
        DateInitial: this.$options.filters.addDay(new Date(), -7),
        DateEnd: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        Bank: { Code: null },
        EntryType: { Code: null },
        CodeHistory: null,
        BankAccounts: { Code: this.$route.params.idAccount  },
        Description: null
      };
    },
    ResetListBank: function() {
      this.DateTableInitial = this.$options.filters.addDay(new Date(), -1);
      this.DateTableEnd = this.$options.filters.date(new Date(), "YYYY-MM-DD");
      this.ResetFilter();
      this.ListBankStatement();
    },
    ListBankStatement: function() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Bank) && hasValue(this.filter.Bank.Code))
        this.countFilter++;
      if (
        hasValue(this.filter.BankAccounts) &&
        hasValue(this.filter.BankAccounts.Code)
      )
        this.countFilter++;
      if (hasValue(this.filter.Description)) this.countFilter++;
      if (hasValue(this.filter.DateInitial)) this.countFilter++;
      if (hasValue(this.filter.DateEnd)) this.countFilter++;

      let data = {
        ...this.pagination,
        DateInitial: this.$options.filters.date(
          this.filter.DateInitial,
          "YYYY-MM-DD"
        ),
        DateEnd: this.$options.filters.date(this.filter.DateEnd, "YYYY-MM-DD"),

        CodeHistory: this.filter.CodeHistory,
        Description: this.filter.Description,

        "Object.BankAccounts.Code": this.filter.BankAccounts.Code,
        "Object.BankAccounts.Bank.Code": this.filter.Bank.Code,
        "EntryType.Code": this.filter.EntryType.Code,
        "Object.EntryDate": this.$options.filters.date(
          this.filter.EntryDate,
          "YYYY-MM-DD"
        )
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListBankStatement", { params: data })
        .then(response => {
          this.BankStatements = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    preventDecimal(e) {
      if (e.Code == "Comma" || e.Code == "Period" || e.Code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
td {
  padding: 10px;
}
.tdEspaco {
  display: table;
  float: left;
  margin-right: 10px;
}
table {
  border-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BankStatement.vue